<template>
  <section class="sport-mobile">
    <MBookmakerHomePage class="bookmaker" />
    <MPageTournamentCard v-if="tournament" :card="tournament" />
    <LastBets v-if="isVisible" :tabs="tabs" header-size="mobile" />
  </section>
</template>

<script setup lang="ts">
import MPageTournamentCard from '@st/tournaments/components/TournamentCard/MPageTournamentCard.vue'
import MBookmakerHomePage from '@st/bookmaker/components/BookmakerHomePage/MBookmakerHomePage.vue'
import { useLastBets } from '@st/casino/composables/useLastBets'

definePageMeta({
  layout: 'mobile-with-footer',
})

const { tabs, isVisible } = useLastBets('sport')

const { tournament } = usePageTournament('bookmaker')

useSeoData('sport')
</script>

<style scoped>
.sport-mobile {
  margin-bottom: var(--spacing-450);
}

.bookmaker {
  padding-bottom: var(--spacing-200);
}
</style>
